// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.assessment.MedicalDecisionMakingResponse */
/* istanbul ignore next */
@GandalfModel
export class MedicalDecisionMakingResponse extends GandalfModelBase {

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	encounterDate!: Date | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfConstantDecorator(constants.MedicalDecisionMakingComplexity)
	@GandalfProperty({ designType: constants.MedicalDecisionMakingComplexity })
	medicalDecisionMakingComplexity!: constants.MedicalDecisionMakingComplexity | null;

	@GandalfConstantDecorator(constants.MedicalDecisionMakingConsultation)
	@GandalfProperty({ designType: constants.MedicalDecisionMakingConsultation })
	medicalDecisionMakingConsultation!: constants.MedicalDecisionMakingConsultation | null;

	@GandalfConstantDecorator(constants.MedicalDecisionMakingNumDx)
	@GandalfProperty({ designType: constants.MedicalDecisionMakingNumDx })
	medicalDecisionMakingNumDxLevel!: constants.MedicalDecisionMakingNumDx | null;

	@GandalfConstantDecorator(constants.MedicalDecisionMakingRisk)
	@GandalfProperty({ designType: constants.MedicalDecisionMakingRisk })
	medicalDecisionMakingRisk!: constants.MedicalDecisionMakingRisk | null;

}
